<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目结束</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="备注信息" prop="success_remark">
                                        <Input v-model="Forms.success_remark" type="textarea" :rows="8" clearable placeholder="备注信息" />
                                    </FormItem>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认结束</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {workOverProject} from "@/apis/project";

export default {
    name: 'ProjectOver',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目结束',
            isBox : false,
            Forms : {
                project_id: '',
                success_remark: '',
            }
        }
    },
    methods: {

        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 项目结束';
            if(project_id){
                this.Forms.project_id = project_id;
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    workOverProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目结束';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
